import { useCurrentUser } from '@shared/hooks';
import { ReactNode } from 'react';

export const CheckImpersonation = ({ children }: { children: ReactNode }) => {
  const { user } = useCurrentUser();
  const isImpersonated = user?.impersonator;

  return isImpersonated ? null : children;
};
